/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cargos_As_Of_Pre_History_WarningInputs */

const en_cargos_as_of_pre_history_warning = /** @type {(inputs: Cargos_As_Of_Pre_History_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audit history begins ${i?.date}. Snapshots dated before this are incomplete and may be inaccurate.`)
};

const es_cargos_as_of_pre_history_warning = /** @type {(inputs: Cargos_As_Of_Pre_History_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El historial de auditoría comienza el ${i?.date}. Las instantáneas anteriores a esta fecha están incompletas y pueden ser inexactas.`)
};

/**
* | output |
* | --- |
* | "Audit history begins {date}. Snapshots dated before this are incomplete and may be inaccurate." |
*
* @param {Cargos_As_Of_Pre_History_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_pre_history_warning = /** @type {((inputs: Cargos_As_Of_Pre_History_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_Pre_History_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_pre_history_warning(inputs)
	return es_cargos_as_of_pre_history_warning(inputs)
});